import type { PropsWithChildren } from 'react'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createAccessControlProvider } from '@frontend/components/agromarket/core/access-control'
import { getAuthState } from '@/logic/auth/reducer'
import { getIsLoanApproved } from '@/logic/profile/reducer'
import type { RootState } from '@/redux/interfaces'
import { FINANCING_ACCESS_CONTROL_LIST } from './constants'
import type { TFinancingAccessControlContext, TFinancingAccessControlList } from './types'

export const { AccessControlProvider, useAccessControl: useFinancingAccessControl } = createAccessControlProvider<
  TFinancingAccessControlList,
  TFinancingAccessControlContext
>(FINANCING_ACCESS_CONTROL_LIST)

const mapState = (state: RootState) => ({
  auth: getAuthState()(state),
  isLoanApproved: getIsLoanApproved()(state),
})

export const FinancingAccessControlProvider = ({ children }: PropsWithChildren<{}>) => {
  const { auth, isLoanApproved } = useSelector(mapState)

  const context = useMemo(
    () => ({
      auth,
      isLoanApproved,
    }),
    [auth, isLoanApproved],
  )

  return <AccessControlProvider context={context}>{children}</AccessControlProvider>
}
